var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.286133 12.98V16.3951H3.70131L13.7738 6.32263L10.3586 2.90746L0.286133 12.98ZM16.4149 3.68156C16.7701 3.32638 16.7701 2.75263 16.4149 2.39746L14.2838 0.266384C13.9286 -0.0887946 13.3549 -0.0887946 12.9997 0.266384L11.3331 1.93299L14.7483 5.34817L16.4149 3.68156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ac41b61f6b87cc2863f013654a8ca184.svg";
export { ForwardRef as ReactComponent };